import script from "./LayoutView.vue?vue&type=script&lang=ts&name=LayoutView&setup=true"
export * from "./LayoutView.vue?vue&type=script&lang=ts&name=LayoutView&setup=true"

import "./LayoutView.vue?vue&type=style&index=0&id=15fd6abd&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15fd6abd"]])

export default __exports__